module.exports = __webpack_public_path__ + "img/fuehrung_und_organisation.692c7c8d.png";